import React from 'react';
import { Transition } from '@headlessui/react';
import { Loader } from 'ui';

type Props = {
  fluid?: boolean;
  basic?: boolean;
  well?: boolean;
  padded?: boolean;
  secondary?: boolean;
  primary?: boolean;
  color?: HTMLDivElement['className'];
  loading?: boolean;
  attached?: 'top' | 'bottom';
  classNames?: (classNames: string[]) => string[];
  onClick?: () => void;
  children?: React.ReactNode;
};

function Segment({
  fluid = false,
  basic = false,
  well = false,
  padded = false,
  secondary = false,
  primary = false,
  color,
  attached,
  loading = false,
  onClick,
  classNames = (classNames: string[]) => classNames,
  children,
}: Props) {
  const classes = ['relative'];
  const innerClassNames = [];

  // Bgcolor
  if (color) {
    classes.push(color);
  } else if (well) {
    classes.push('bg-gray-200');
  } else if (secondary) {
    classes.push('bg-gray-50');
  } else if (primary) {
    classes.push('bg-primary-50');
  } else {
    classes.push('bg-white');
  }

  // Shadow
  if (well) {
    classes.push('shadow-inner');
  } else {
    classes.push('shadow');
  }

  if (onClick) {
    classes.push('hover:bg-gray-50', 'cursor-pointer');
  }

  if (basic) {
    // no padding
  } else if (padded) {
    innerClassNames.push('px-4', 'py-8', 'sm:px-10');
  } else {
    innerClassNames.push('px-4', 'py-5', 'sm:p-6');
  }

  switch (attached) {
    case 'top':
      classes.push('rounded-b-lg');
      break;
    case 'bottom':
      classes.push('rounded-t-lg');
      break;
    default:
      classes.push('rounded-lg');
      break;
  }

  if (fluid) {
    classes.push('w-full');
  }

  return (
    <div role="presentation" className={classNames(classes).join(' ')} onClick={onClick}>
      <Transition
        className="absolute inset-0 z-20"
        show={loading}
        enter="transition ease-in duration-50"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="transition ease-out duration-50"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
      >
        <div className="absolute inset-0 z-20 flex items-center justify-center rounded-lg bg-white opacity-70">
          <Loader size="huge" />
        </div>
      </Transition>
      <div className={innerClassNames.join(' ')}>{children}</div>
    </div>
  );
}

export default Segment;
